module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "workshops-courses"
  }, [_c('nav-1'), _vm._v(" "), _c('hero', {
    attrs: {
      "image": _vm.hero
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_c('mailchimp')], 1)]), _vm._v(" "), _vm._m(1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-text"
  }, [_c('h1', [_vm._v("Short Courses")]), _vm._v(" "), _c('h4', {
    staticClass: "size__content__narrow pos__content__center"
  }, [_vm._v("\n      Exciting news! We are curating a new course offering which provides a comprehensive and in-depth introduction to a range of design and printing techniques. Drawing on our vast experience, each workshop is conducted in small groups, ensuring maximum support and guidance from our experienced tutors.\n      "), _c('br'), _c('br'), _vm._v("\n      Sign up to register your interest\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "action-wrapper"
  }, [_c('div', {
    staticClass: "action"
  }, [_c('h3', [_vm._v("Get in touch to learn more about our courses, or any general enquiries on workshops.")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:learn@hatopress.net"
    }
  }, [_vm._v("learn@hatopress.net")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+44-207-729-5585"
    }
  }, [_vm._v("+44 (0)207 729 5585")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-346ba20b","transformToRequire":{"img":"src","audio":"src","video":"poster"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/WorkshopsCourses.vue
// module id = 208
// module chunks = 1